import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {MatExpansionModule} from "@angular/material/expansion";
import {MatListModule} from "@angular/material/list";
import {NavigationEnd, Router} from "@angular/router";
import {MenuSection} from "@app/pages/admin-panel/admin-menu.service";
import {MenuSectionItemComponent} from "@app/pages/admin-panel/menu-section-item/menu-section-item.component";
import {filter, Subscription} from "rxjs";

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  imports: [
    MatExpansionModule,
    MatListModule,
    MenuSectionItemComponent,
  ],
  standalone: true
})
export class MenuSectionComponent implements OnInit, OnDestroy {
  @Input() section!: MenuSection;

  private readonly router = inject(Router);
  private routerSub?: Subscription;

  ngOnInit(): void {
    // CS-823 task-13: auto-expand the panel that holds the active route so the
    // highlighted (currently-visited) page is visible without hunting for it.
    this.expandIfActive();
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.expandIfActive());
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  /** Open this section when one of its items matches the current URL. */
  private expandIfActive(): void {
    if (this.section.hasSectionItems && this.containsActiveRoute()) {
      this.section.selected = true;
    }
  }

  private containsActiveRoute(): boolean {
    return this.section.sectionItems.some(item => {
      const link = Array.isArray(item.routerLink) ? item.routerLink[0] : item.routerLink;
      return typeof link === 'string' && this.router.isActive(link, {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      });
    });
  }
}
